import { useCallback } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Checkbox } from '../../../../input/Checkbox';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { Column, Row } from '../../styles';
import { ROW_HEIGHT } from './constants';
import { ContentPromotionGoalsDialogHeaderProps } from './types';

export const ContentPromotionGoalsDialogHeader: React.FC<
    ContentPromotionGoalsDialogHeaderProps
> = ({ selected, onSelect }) => {
    const t = useTranslation();

    const onToggleSelected = useCallback(() => onSelect(!selected), [selected, onSelect]);

    return (
        <Row py={0} pr={1} height={ROW_HEIGHT}>
            <Column>
                <Checkbox checked={selected} onChange={onToggleSelected} />
            </Column>
            <Flex flexShrink={0}>
                <Typography variant="body" weight="medium">
                    {t('Цель')}
                </Typography>
            </Flex>
        </Row>
    );
};
